<template lang="html">

  <div>

    <router-link v-if="!!!external" class="row-start" :to="to" :target="(blank) ? '_blank' : '_self'">

      <span :style="style.colorBasic">{{text}}

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve" width="30px" height="30px">
        <path d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111  C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587  c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" :fill="colors.basic"/>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
      </svg>

      </span>

    </router-link>



    <a v-if="!!external" class="row-start" :href="to" :target="(blank) ? '_blank' : '_self'">

      <span :style="style.colorBasic">{{text}}

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve" width="30px" height="30px">
        <path d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111  C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587  c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" :fill="colors.basic"/>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
      </svg>
      
      </span>
    
      <a @click="eliminar" href="#" style="margin-left:5px;margin-bottom:5px;z-index:100;color: #c31632; font-weight: 800;">✕</a>

    </a>

  </div>


</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'add',
    props: ['text', 'to', 'blank', 'external','sametab'],
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles'
      })
    },
    methods : {      
      eliminar(){
        this.$emit('eliminar');
      }
    }
  }
</script>

<style scoped lang="scss">
span{
  font-size: 14px;
  text-transform: uppercase;
  margin-right: 5px;
  margin-bottom: 10px;
  font-weight: 600;
}

svg{
  width: 15px;
  margin: 0 0 -9px 3px;
}

@media screen and (max-width: 360px){
    span{
        font-size: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/icons/arrow-link-with-del.vue